export const enRepsolLang = {
  buildings: 'Buildings',
  device_groups: 'Device groups',
  para_realizar_un_pedido:
    'To place an order, please select the device type and device group first. You can indicate a date of receipt. Next, click on each device to add quantities to the transport.',
  edit_group_device: 'Edit device group',
  create_device_groups: 'Create device group',
  add_group_device: 'Add a device group',
  device_group: 'Device group',
  aprox_unit: 'Approximate volume',
  product_type: 'Gasoil type'
};
